var map = {
	"./AlexFolds.png": 53013,
	"./AlexTabs.png": 75709,
	"./Background.png": 23897,
	"./Labels.png": 36846,
	"./SteveFolds.png": 67658,
	"./SteveTabs.png": 31694
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57314;